import React, {useState} from 'react';
import {Box, IconButton} from '@mui/material';
import Folder from "../../../../../models/Folder";
import FolderIcon from '@mui/icons-material/Folder';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationModal from "../../../../shared/modals/ConfirmationModal";
import GenericEditNameModal from '../modals/GenericEditNameModal';
import {AssetBoxContainer, AssetBoxWrapper, AssetLabel} from "./AssetBoxStyle";

interface AssetBoxFolderProps {
    folder: Folder;
    handleFolderClick: (folder: Folder) => void;
    handleFolderDelete: (folder: Folder) => void;
    handleFolderEdit: (folder: Folder) => void;
}

const AssetBoxFolder: React.FC<AssetBoxFolderProps> = ({
                                                           folder,
                                                           handleFolderClick,
                                                           handleFolderDelete,
                                                           handleFolderEdit
                                                       }) => {
    const [isHovering, setIsHovering] = useState(false);
    const [isEditDialogOpen, setEditDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const handleMouseEnter = () => setIsHovering(true);
    const handleMouseLeave = () => setIsHovering(false);

    const handleEditDialogOpen = () => setEditDialogOpen(true);

    const handleDeleteDialogOpen = () => setDeleteDialogOpen(true);
    const handleDeleteDialogClose = () => setDeleteDialogOpen(false);

    const confirmDelete = () => {
        handleFolderDelete(folder);
        handleDeleteDialogClose();
    };

    return (
        <>
            <AssetBoxContainer
                item
                xs={4}
                md={3}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <AssetBoxWrapper
                    onClick={() => handleFolderClick(folder)}
                >

                    <FolderIcon
                        sx={{
                            width: "50px",
                            height: "50px",
                            display: "block",
                            objectFit: "contain",
                            margin: "auto",
                            color: "black"
                        }}
                    />
                    {isHovering && (
                        <Box
                            sx={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                padding: "1px",
                                justifyContent: "space-between",
                                width: "100%",
                                background: "linear-gradient(180deg, #707070, transparent)"
                            }}>
                            <IconButton size="small" sx={{color: "black"}} onClick={(e) => {
                                e.stopPropagation();
                                handleEditDialogOpen();
                                setTimeout(() => setIsHovering(false), 100);
                            }}>
                                <EditIcon fontSize="small"/>
                            </IconButton>
                            <IconButton size="small" sx={{color: "#ff3f3f"}} onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteDialogOpen();
                                setTimeout(() => setIsHovering(false), 100);
                            }}>
                                <DeleteIcon fontSize="small"/>
                            </IconButton>
                        </Box>
                    )}
                </AssetBoxWrapper>
                <AssetLabel>
                    {folder.name}
                </AssetLabel>
            </AssetBoxContainer>

            {isEditDialogOpen &&
                <GenericEditNameModal<Folder>
                    entity={folder}
                    open={isEditDialogOpen}
                    onClose={() => setEditDialogOpen(false)}
                    onEntityEdited={handleFolderEdit}
                    apiEndpoint="/folder"
                    dialogTitle="ערוך שם לתיקיה"
                    successMessage="התיקיה נערכה בהצלחה"
                    errorMessage="תקלה בעת עריכת התיקיה"
                    placeholder="שם התיקיה"
                    inputError="שם התיקיה נדרש"
                />}

            {isDeleteDialogOpen && <ConfirmationModal
                show={isDeleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                onConfirm={confirmDelete}
                title="אישור מחיקה"
                message={`האם אתה בטוח שאתה רוצה למחוק את התיקיה "${folder.name}"?`}
            />}
        </>
    );
};

export default AssetBoxFolder;
